import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=184abdd4&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=184abdd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184abdd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('184abdd4')) {
      api.createRecord('184abdd4', component.options)
    } else {
      api.reload('184abdd4', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=184abdd4&scoped=true&", function () {
      api.rerender('184abdd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8Ss7mg8owysBL/JS/comp/SearchFilterTokens.vue"
export default component.exports